import axios from 'axios'
import Decimal from 'decimal.js'
import $store from '@/store/index'
import GridReadApis from '@/util/gridrapis'
import util from '@/util/util'

function parseRate (rawRate) {
  return new Decimal(rawRate).mul(100).toDecimalPlaces(4, Decimal.ROUND_UP).toNumber()
}

async function fetchBybit (symbol) {
  const exchSymbol = symbol.replace('_', '')
  const resp = await axios.get('https://api.bybit.com/v5/market/tickers?category=linear&symbol=' + exchSymbol, { withCredentials: false })
  const item = resp.data && resp.data.result && resp.data.result.list && resp.data.result.list[0]
  if (item && item.fundingRate) {
    const rate = parseRate(item.fundingRate)
    console.log('[FundingRate] OK via Bybit public:', rate + '%', symbol)
    return rate
  }
  return null
}

async function fetchBitget (symbol) {
  const exchSymbol = symbol.replace('_', '')
  const resp = await axios.get('https://api.bitget.com/api/v2/mix/market/current-fund-rate?productType=USDT-FUTURES&symbol=' + exchSymbol, { withCredentials: false })
  const item = resp.data && resp.data.data && resp.data.data[0]
  if (item && item.fundingRate) {
    const rate = parseRate(item.fundingRate)
    console.log('[FundingRate] OK via Bitget public:', rate + '%', symbol)
    return rate
  }
  return null
}

async function fetchBinance (symbol) {
  const exchSymbol = symbol.replace('_', '')
  const resp = await axios.get('https://fapi.binance.com/fapi/v1/premiumIndex?symbol=' + exchSymbol, { withCredentials: false })
  const item = resp.data
  if (item && item.lastFundingRate) {
    const rate = parseRate(item.lastFundingRate)
    console.log('[FundingRate] OK via Binance public:', rate + '%', symbol)
    return rate
  }
  return null
}

async function fetchOkx (symbol) {
  const instId = symbol.replace('-PERP', '').replace('_', '-') + '-SWAP'
  const resp = await axios.get('https://www.okx.com/api/v5/public/funding-rate?instId=' + instId, { withCredentials: false })
  const item = resp.data && resp.data.data && resp.data.data[0]
  if (item && item.fundingRate) {
    const rate = parseRate(item.fundingRate)
    console.log('[FundingRate] OK via OKX public:', rate + '%', symbol)
    return rate
  }
  return null
}

const exchangeFetchers = {
  BYF: fetchBybit,
  GEF: fetchBitget,
  BIF: fetchBinance,
  OKX: fetchOkx
}

async function fetchGridsRead (eid, symbol) {
  const params = { eid, symbol }
  const headers = { 'CTKN': $store.state.sys.token }
  try {
    const response = await GridReadApis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('funding_rate', { params, headers })
    console.log('[FundingRate] OK via gridsapi:', response.data.Rate + '%', symbol)
    return response.data.Rate
  } catch (apiError) {
    console.warn('[FundingRate] gridsapi failed, trying public exchange endpoint...', apiError.message || apiError)
    const fetcher = exchangeFetchers[eid]
    if (fetcher) {
      return await fetcher(symbol)
    }
    return null
  }
}

export default {
  async FetchFundingRate (eid, symbol) {
    if (!eid || !symbol) {
      return null
    }
    try {
      const fetcher = exchangeFetchers[eid]
      return fetcher ? await fetcher(symbol) : null
      // if (eid === 'BYF' || eid === 'GEF') {
      //   // Bybit and Bitget: try our API first, fallback to public exchange API
      //   return await fetchGridsRead(eid, symbol)
      // } else {
      //   // Other exchanges: direct public exchange API
      //   const fetcher = exchangeFetchers[eid]
      //   return fetcher ? await fetcher(symbol) : null
      // }
    } catch (e) {
      console.warn('[FundingRate] Failed:', e)
      return null
    }
  }
}
